export function isValidLink(field?: any): boolean {
  if (field && field.value && field.value.text) {
    return field.value.text.trim() !== '';
  }
  return false;
}
